export default __webpack_public_path__ + "static/media/masters.637d8902.svg";